import { createBrowserRouter } from 'react-router-dom';
import RootLayout from '../layout/RootLayout';
import ErrorPage from '../pages/ErrorPage';
import RequireAuth from './RequireAuth';
import routes from './routes';

const publicRoutes = routes.filter((f) => !f.isAuthRoute);
const authRoutes = routes.filter((f) => f.isAuthRoute);

const appRouter = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      ...publicRoutes.map(({ path, Component }) => ({ path, Component })),
      {
        Component: RequireAuth,
        children: [
          ...authRoutes.map(({ path, Component }) => ({ path, Component })),
          {
            path: '*', // catch-all route for 404
            Component: ErrorPage,
          },
        ],
      },
    ],
  },
]);

export default appRouter;
